// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import GridContainer, { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import GridItem, { GridItemProps } from "@store/MobiusOverrides/GridItem/GridItem";
import constants from "@store/constants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridPresetGapStyles } from "@toolkit/Themes/common/mixins/grid";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface RequestOrderComplaintInformationStyles {
    wrapper?: GridContainerProps;
    gridItems?: GridItemProps;
    fieldWrapper?: InjectableCss;
    titleText?: TypographyProps;
    infoText?: TypographyProps;
}

export const requestOrderComplaintInformationStyles: RequestOrderComplaintInformationStyles = {
    wrapper: {
        gap: 0,
        css: css`
            ${x => gridPresetGapStyles(x.theme.design.form.grid.base)}
        `,
    },
    gridItems: { width: [12, 6, 6, 4, 4] },
    fieldWrapper: {
        css: css`
            margin-right: ${pxToRem(25)};
        `,
    },
    titleText: {
        as: "h2",
        variant: "h6",
        css: css`
            margin-bottom: ${pxToRem(5)};
        `,
    },
    infoText: {
        as: "p",
    },
};

const styles = requestOrderComplaintInformationStyles;

const RequestOrderComplaintInformation: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    const userInfos = useAppSelector(state => {
        const { firstName, userName, email, lastName } = state.context.session;
        return { firstName, userName, email, lastName };
    });
    if (!order) {
        return null;
    }
    return (
        <>
            <GridContainer {...styles.wrapper}>
                <GridItem {...styles.gridItems}>
                    <StyledWrapper {...styles.fieldWrapper}>
                        <Typography {...styles.titleText}>{translate("Contact Details")}</Typography>
                        <Typography {...styles.infoText} aria-labelledby="requestOrderComplaintOrderNumber">
                            {`${userInfos.firstName || userInfos.userName} ${userInfos.lastName}`}
                        </Typography>
                        <Typography {...styles.infoText} aria-labelledby="requestOrderComplaintOrderNumber">
                            {userInfos.email || ""}
                        </Typography>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.gridItems}>
                    <StyledWrapper {...styles.fieldWrapper}>
                        <Typography {...styles.titleText}>{translate("Customer Details")}</Typography>
                        <Typography {...styles.infoText} aria-labelledby="requestOrderComplaintOrderNumber">
                            {`${translate("Sold-to number")}: ${order.customerNumber}`}
                        </Typography>
                        <Typography {...styles.infoText} aria-labelledby="requestOrderComplaintOrderNumber">
                            {`${translate("Sold-to name")}: ${order.btCompanyName}`}
                        </Typography>
                        <Typography {...styles.infoText} aria-labelledby="requestOrderComplaintOrderNumber">
                            {`${translate("Ship-to address")}: ${order.customerSequence}`}
                        </Typography>
                        <Typography {...styles.infoText} aria-labelledby="requestOrderComplaintOrderNumber">
                            {`${translate("Ship-to name")}: ${order.stAddress1}`}
                        </Typography>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.gridItems}>
                    <StyledWrapper {...styles.fieldWrapper}>
                        <Typography {...styles.titleText} id="requestOrderComplaintPONumber">
                            <span aria-hidden>{translate("Order Details")}</span>
                            <VisuallyHidden>{translate("Purchase Order Number")}</VisuallyHidden>
                        </Typography>
                        <Typography {...styles.infoText} aria-labelledby="requestOrderComplaintPONumber">
                            {`${translate("Your PO")}: ${order.customerPO}`}
                        </Typography>
                        <Typography {...styles.infoText} aria-labelledby="requestOrderComplaintOrderNumber">
                            {`${translate("Greif Order")}: ${order.erpOrderNumber || order.webOrderNumber}`}
                        </Typography>
                        {order.properties.warehouse && (
                            <Typography {...styles.infoText} aria-labelledby="requestOrderComplaintOrderNumber">
                                {`${translate("Ship From")}: ${order.properties.warehouse}`}
                            </Typography>
                        )}
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: RequestOrderComplaintInformation,
    definition: {
        allowedContexts: ["OrderComplaintPage" as any],
        group: constants.widgetGroup.orderComplaint,
        fieldDefinitions: [],
    },
};

export default widgetModule;
